import React from "react";

/**
 * HOT FRAT pilot questionnaire — org-specific compliance block printed on the
 * W&B manifest for Jack Harter Helicopters (FAA request). Single source of truth
 * for the copy: the same `WeightAndBalanceManifest` component is rendered on BOTH
 * the legacy AirTourPro day-view print AND the Month V2 print manifest
 * (`buildWeightBalanceManifest` renders this component), so one insertion covers
 * every printout.
 *
 * Text is VERBATIM from the client document (keep the en-dashes and punctuation).
 */

// Orgs that print the FRAT block. Extend if other orgs request it later.
export const FRAT_ORGS = ["jack-harter-helicopters"];

/**
 * Whether the given org unique should print the FRAT block (case-insensitive).
 *
 * @param {string} orgUnique The page/event org unique (`event.organizationUnique`).
 * @returns {boolean}
 */
export const isFratOrg = orgUnique =>
  typeof orgUnique === "string" && FRAT_ORGS.includes(orgUnique.trim().toLowerCase());

export const FRAT_TITLE = "Jack Harter Helicopters, Inc.";
export const FRAT_SUBTITLE = "HOT FRAT";
export const FRAT_PILOT_INITIALS_LABEL = "Pilot Initials:";

// 5 questions, each with an a./b. sub-line. Verbatim.
export const FRAT_QUESTIONS = [
  {
    n: 1,
    q: "Was the weather significantly worse than forecast for this flight?",
    a: "Yes – Shut down, update weather sources and conduct a new Cold FRAT",
    b: "No – Proceed to the next question"
  },
  {
    n: 2,
    q: "Has the weather visually deteriorated since the previous flight?",
    a: "Yes – Check Webcams before proceeding to the next question",
    b: "No – Proceed to the next question"
  },
  {
    n: 3,
    q:
      "Are all of the normal tour routes (CCI, CRV, NPR, HOTI) showing Challenging Weather on Webcams? (If the Webcam check is not required, proceed to the next question)",
    a: "Yes – Shut down, update weather sources and conduct a new Cold FRAT",
    b: "No – Select a route without CWX and proceed to the next question"
  },
  {
    n: 4,
    q: "Are you switching to a new M/M/S or a different flight profile for this flight?",
    a: "Yes – Shut down, update weather sources and conduct a new Cold FRAT",
    b: "No – Proceed to the next question"
  },
  {
    n: 5,
    q: "Are there any other safety factors that would require a new Cold FRAT for this flight?",
    a: "Yes – Shut down, update weather sources and conduct a new Cold FRAT",
    b: "No – Proceed with your selected flight route as scheduled"
  }
];

/**
 * Print-ready FRAT questionnaire block. Plain print text (no navy styling) — see
 * the `.frat*` rules in `weight-and-balance-manifest.constants.js`. Numbers +
 * a./b. indents; a right-aligned "Pilot Initials:" line closes the block.
 */
export const FratQuestionnaire = () => {
  return (
    <div className="frat">
      <div className="frat-header">
        <div className="frat-title">{FRAT_TITLE}</div>
        <div className="frat-subtitle">{FRAT_SUBTITLE}</div>
      </div>

      {FRAT_QUESTIONS.map(item => (
        <div className="frat-item" key={item.n}>
          <div className="frat-question">
            {item.n}. {item.q}
          </div>
          <div className="frat-sub">a. {item.a}</div>
          <div className="frat-sub">b. {item.b}</div>
        </div>
      ))}

      <div className="frat-initials">{FRAT_PILOT_INITIALS_LABEL} ________________</div>
    </div>
  );
};
